import dom from '../../../wrapper/DomWrapper';

import errorHandler from './errorHandler';
import pictureErrorHandler from './pictureErrorHandler';

const photoErrorHandler = () => {
  const selectorName = '.picture-wrap';
  const onError = (elImage, elParent) => {
    pictureErrorHandler(elImage, elParent, () => {
      dom.addClass(elParent, 'picture-wrap_unavailable');
    });
  };

  errorHandler(selectorName, onError);
};

export default photoErrorHandler;
